"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapGqlDataToAccordion = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const mapGqlDataToAccordion = graphqlFaqContent => {
  if (!graphqlFaqContent || graphqlFaqContent.length < 1) {
    return null;
  }
  return graphqlFaqContent.map(question => {
    const {
      title,
      content
    } = question;
    const htmlText = content.map(contentItem => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.TextWithHtml, {
      html: (0, _utils.transformHtmlContent)(contentItem)
    }, contentItem.text ?? title));
    return {
      id: title ?? '',
      title: title ?? '',
      content: htmlText
    };
  });
};
exports.mapGqlDataToAccordion = mapGqlDataToAccordion;
